import { UI_START_LOADING, UI_STOP_LOADING } from "../types/uiTypes";

type ActionI =
    { type: typeof UI_START_LOADING } |
    { type: typeof UI_STOP_LOADING }

type StateI = {
    loading: boolean;
}

const initialState = {
    loading: false
}

export const uiReducer = (state = initialState, action:ActionI): StateI => {

    switch(action.type){
        case UI_START_LOADING:
            return {...state, loading: true};

        case UI_STOP_LOADING:
            return {...state, loading: false};

        default:
            return state;
    }

}
